document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-mobile-toggle]');
  if (!toggle) return;
  const isOpen = document.body.classList.toggle('nav-open');
  toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
});

document.addEventListener('change', function (event) {
  if (!event.target.matches('[data-option-select]')) return;
  const form = event.target.closest('[data-product-form]');
  if (!form) return;
  let variants = [];
  try { variants = JSON.parse(form.getAttribute('data-variants') || '[]'); } catch (e) { return; }
  const selected = Array.from(form.querySelectorAll('[data-option-select]')).map(select => select.value);
  const variant = variants.find(item => selected.every((value, index) => item.options[index] === value));
  if (!variant) return;
  const variantInput = form.querySelector('[data-variant-id]');
  const button = form.querySelector('[data-submit-button]');
  if (variantInput) variantInput.value = variant.id;
  if (button) {
    button.disabled = !variant.available;
    button.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
  }
});
